export default __webpack_public_path__ + "static/media/children.f4be0642.png";